module.exports = __webpack_public_path__ + "static/media/vehicle-icon.63156c8c.svg";